import global from '../globalvars';

export default class VideoText {
	constructor(elm) {
		const self = this;
		this.elm = elm;

		this.video = this.elm.querySelector('[data-vimeo]');

		if (!this.video) {
			return;
		}

		this.videoID = this.video.getAttribute('data-id');

		this.video.addEventListener('click', function () {
			if (self.videoID) {
				global.getVideoModal().open(self.videoID);
			}
		});
	}
}
